import { render, staticRenderFns } from "./spineAssessment.vue?vue&type=template&id=41c8d09f&scoped=true&"
import script from "./spineAssessment.vue?vue&type=script&lang=js&"
export * from "./spineAssessment.vue?vue&type=script&lang=js&"
import style0 from "./spineAssessment.vue?vue&type=style&index=0&id=41c8d09f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c8d09f",
  null
  
)

export default component.exports